import "polyfills";
import { createRoot } from "react-dom/client";
import "typeface-roboto";
import { format } from "date-fns";

//redux
import { Provider } from "react-redux";
import { store } from "store";
//theme
import { ThemeProvider } from "@mui/system";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import WintTheme from "theme/wintTheme";

// Use the meta insertion point in index.html so Emotion styles load BEFORE app CSS.
// This ensures custom Sass classes override MUI's generated Emotion classes.
const emotionInsertionPoint = document.querySelector<HTMLMetaElement>('meta[name="emotion-insertion-point"]');
const emotionCache = createCache({
  key: "css",
  ...(emotionInsertionPoint ? { insertionPoint: emotionInsertionPoint } : {}),
});
import "theme/styles/wint.css";
//App
import App from "App";

import initializeSentry from "utils/sentryInitialize";

/*eslint no-extend-native: ["error", { "exceptions": ["Date"] }]*/
// this is to fix the issue with stringify method of Date objects turn the date to UTC date time string
Date.prototype.toJSON = function () {
  try {
    return format(this, "yyyy-MM-dd'T'HH:mm:ss.SSS");
  } catch {
    return "";
  }
};

initializeSentry();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <CacheProvider value={emotionCache}>
    <Provider store={store}>
      <ThemeProvider theme={WintTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  </CacheProvider>
);

// Clean up legacy service worker (can be removed once all users have loaded the new version)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      for (const registration of registrations) {
        registration.unregister().catch(() => {});
      }
    })
    .catch(() => {});
}
